import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import BoardTable from "../../components/BoardTable";
import BoardSearch from "../../components/BoardSearch";

import useApi from "../../hooks/api/axiosInterceptor";

const Wrapper = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;
    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    text-align: center;
`;

const AutonomyActivity = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [boardPosts, setBoardPosts] = useState([]);
    const [totalPosts, setTotalPosts] = useState(0);
    const [searchParams, setSearchParams] = useState({
        type: '',
        term: ''
    });
    
    const postsPerPage = 10; // 페이지당 게시물 수
    const totalPages = Math.ceil(totalPosts / postsPerPage);
    
    // 게시물 데이터 가져오기
    const fetchBoardData = async () => {
        setIsLoading(true);
        try {
            const offset = (page - 1) * postsPerPage;
            
            // 검색 파라미터 추가
            let url = `/dbtest?board=activity&offset=${offset}&limit=${postsPerPage}`;
            
            if (searchParams.type && searchParams.term) {
                url += `&searchType=${searchParams.type}&searchTerm=${encodeURIComponent(searchParams.term)}`;
            }
            
            const response = await useApi.get(url);
            if (response.data.result === 'SUCCESS') {
                setBoardPosts(response.data.data);
                
                if (response.data.totalCount) {
                    setTotalPosts(response.data.totalCount);
                }
            } else {
                console.error("데이터 가져오기 실패:", response.data.message);
            }
        } catch (err) {
            console.error("API 요청 오류:", err);
        } finally {
            setIsLoading(false);
        }
    };
    
    useEffect(() => {
        fetchBoardData();
    }, [page, searchParams]);
    
    const handlePageChange = (newPage) => {
        setPage(newPage);
        window.scrollTo(0, 0);
    };
    
    const handleSearch = (type, term) => {
        setSearchParams({ type, term });
        setPage(1); // 검색 시 첫 페이지로 이동
    };

    // 게시글 클릭 시 상세 페이지로 이동

    
    return (
        <Wrapper>
            <BoardSearch onSearch={handleSearch} />
            
            <BoardTable
                posts={boardPosts}
                loading={isLoading}
                basePath="/student-autonomy/activity"
                currentPage={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                searchInfo={searchParams.term ? searchParams : null}

            />
        </Wrapper>
    );
};




export default AutonomyActivity;
